import Modal from '@/components/modules/Modal/Modal';

interface UserDeleteConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function UserDeleteConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
}: UserDeleteConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="회원 삭제 확인" size="md">
      <div className="p-6">
        <p className="text-gray-600 mb-6">
          이 회원을 삭제하시겠습니까? 삭제된 회원은 복구할 수 없습니다.
        </p>
        <div className="flex space-x-3">
          <button
            onClick={onConfirm}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg cursor-pointer whitespace-nowrap"
          >
            삭제
          </button>
          <button
            onClick={onCancel}
            className="flex-1 border border-gray-300 text-gray-700 py-2 rounded-lg cursor-pointer whitespace-nowrap"
          >
            취소
          </button>
        </div>
      </div>
    </Modal>
  );
}
